import React from 'react'

const BedroomIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.08337 11.0834H3.50004L3.12087 9.91675H2.33337V6.9855C2.33337 6.66466 2.44761 6.39244 2.67608 6.16883C2.90455 5.94522 3.17921 5.83342 3.50004 5.83342V4.08341C3.50004 3.76258 3.61428 3.48793 3.84275 3.25946C4.07122 3.03098 4.34587 2.91675 4.66671 2.91675H9.33337C9.65421 2.91675 9.92886 3.03098 10.1573 3.25946C10.3858 3.48793 10.5 3.76258 10.5 4.08341V5.83342C10.8209 5.83342 11.0955 5.94765 11.324 6.17612C11.5525 6.4046 11.6667 6.67925 11.6667 7.00008V9.91675H10.8792L10.5 11.0834H9.91671L9.53754 9.91675H4.46254L4.08337 11.0834ZM7.58337 5.83342H9.33337V4.08341H7.58337V5.83342ZM4.66671 5.83342H6.41671V4.08341H4.66671V5.83342Z'
      fill='currentColor'
    />
  </svg>
)

export default BedroomIcon
